import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { createApp } from 'vue';
import { createGtm } from 'vue-gtm';
import router from './router';
import App from './App.vue';
import { spotwriteStore, stateKey } from './store';
import '@/assets/scss/style.scss';
import 'bootstrap';

const app = createApp(App);
app.use(spotwriteStore, stateKey);

Sentry.init({
  app,
  environment: process.env.VUE_APP_STG,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'dev.spotwrite.site', 'www.spotwrite.site', /^\//],
    }),
  ],
  tracesSampleRate: 0.5,
});

app.use(router);
app.use(
  createGtm({
    id: process.env.VUE_APP_GTM_ID,
  }),
);
app.mount('#app');
